import {useEffect, useState, type FC} from "react"
import {Grid, Box, styled, Paper} from "@mui/material"
import Carousel from "../../components/organisms/Carousel/Carousel"
import {thoughtPiecesEndpoints} from "../../services/api/thought-pieces"
import {useConfigProvider} from "../../config"
import {ThoughtPiecesModel} from "../../types/ThoughtPiecesModel"
import {useQuery} from "@tanstack/react-query"
import {convertThoughtPiecesToCarouselItemList} from "../../helpers/parserHelper"
import {CarouselItemProps} from "../../components/molecules/CarouselItem/types"
import DiscoverSidePanel from "../../components/organisms/DiscoverSidePanel/DiscoverSidePanel"
import DiscoverThoughtPieceMainSection from "../../components/organisms/DiscoverThoughtPieceMainSection/DiscoverThoughtPieceMainSection"
import ErrorBoundary from "../../helpers/ErrorBoundaryRender"
import Error from "../Error/Error"
import {BackButton} from "../../components/molecules/thoughtPiecesFullpage"
import useHomeNavigation from "../../hooks/useHomeNavigation"
import {useTranslation} from "react-i18next"
import {useSessionStorage} from "usehooks-ts"

const Discover: FC = () => {
  const Item = styled(Paper)(({theme}) => ({
    backgroundColor: "#d3d3d3",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }))

  const {addNavigationHistory, clearNavigationHistory} = useHomeNavigation()

  const [carouselItemList, setCarouselItemList] = useState<CarouselItemProps[]>(
    [],
  )
  const {t} = useTranslation()

  const handleGetPodcasts = async () => {
    setCarouselItemList([])
    return await getPodcasts()
  }
  const {getPodcasts} = thoughtPiecesEndpoints()
  const {cmsImageUrl} = useConfigProvider()
  const {
    data: podcastList,
    isLoading,
    isError,
    isLoadingError,
    isRefetchError,
    isFetching,
    isRefetching,
    refetch,
  } = useQuery<ThoughtPiecesModel[]>({
    queryKey: ["getPodcasts"],
    queryFn: async () => await handleGetPodcasts(),
  })

  const [language] = useSessionStorage("language", "en")
  useEffect(() => {
    if (podcastList) {
      setCarouselItemList([
        ...convertThoughtPiecesToCarouselItemList(
          podcastList,
          cmsImageUrl,
          language,
        ),
      ])
    }
  }, [podcastList, isRefetching, language])

  useEffect(() => {
    clearNavigationHistory()
    addNavigationHistory("Discover")
  }, [])

  return (
    <ErrorBoundary
      fallback={
        <Box>
          <BackButton
            style={{
              fontSize: "14px",
              marginTop: "28px",
              marginLeft: "35px",
              lineHeight: "20px",
              pointerEvents: "none",
              cursor: "pointer",
            }}
          />
          <Error
            containerStyle={{
              height: "12rem",
              overflow: "hidden",
              backgroundColor: "#FBFBFB",
            }}
            buttonStyle={{
              border: "solid 1px #053747",
              borderRadius: "4px",
              color: "#053747",
              backgroundColor: "#FBFBFB",
              width: "96px",
              height: "32px",
              fontSize: "16px",
            }}
            buttonHoverStyle={{
              backgroundColor: "#FBFBFB",
            }}
          />
        </Box>
      }
    >
      <Box sx={{flexGrow: 1}}>
        <Grid container spacing={1}>
          <Grid size={8}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                textAlign: "center",
                color: "#212121",
                borderRadius: "8px",
              }}
            >
              <DiscoverThoughtPieceMainSection></DiscoverThoughtPieceMainSection>
            </Box>
          </Grid>
          <Grid size={4}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                textAlign: "center",
                color: "#212121",
                borderRadius: "8px",
              }}
            >
              <DiscoverSidePanel></DiscoverSidePanel>
            </Box>
          </Grid>
          <Grid size={12} style={{paddingTop: "8px"}}>
            <Item
              style={{
                background: "#FFF",
                borderColor: "#f4f4f4",
                border: "solid 1px #eeeeee",
                boxShadow: "0px 4px 4px 0px #EEEEEE",
                padding: "16px 8px",
                borderRadius: "8px",
                marginBottom: "12px",
              }}
            >
              <Carousel
                title={t("Podcasts")}
                dataSource={carouselItemList}
                isLoading={isLoading}
                isFetching={isFetching}
                isError={isError}
                isLoadingError={isLoadingError}
                isRefetchError={isRefetchError}
                isRefetching={isRefetching}
                refetch={refetch}
                style={{
                  mainStyle: {
                    columnGap: 2.35,
                  },
                  titleStyle: {
                    color: "#BA0E68",
                    fontSize: 14,
                    fontStyle: "Open Sans",
                    fontWeight: 600,
                  },
                }}
              />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </ErrorBoundary>
  )
}
Discover.displayName = "Discover"

export default Discover
